import { Controller } from "@hotwired/stimulus"
import { parsePhoneNumber, getCountryCallingCode } from "libphonenumber-js"

// Connects to data-controller="phone-input"
export default class extends Controller {
  static targets = ["countrySelect", "countryCodeDisplay", "numberField", "fullNumber"]

  connect() {
    // Default to US if no value is set
    if (!this.countrySelectTarget.value) {
      this.countrySelectTarget.value = "US"
    }
    this.updateDisplay()

    // If there's an existing full phone number, parse it
    if (this.hasFullNumberTarget && this.fullNumberTarget.value) {
      this.parseExistingNumber()
    }
  }

  parseExistingNumber() {
    try {
      const phoneNumber = parsePhoneNumber(this.fullNumberTarget.value)
      if (phoneNumber) {
        this.countrySelectTarget.value = phoneNumber.country
        this.numberFieldTarget.value = phoneNumber.nationalNumber
        this.updateDisplay()
      }
    } catch (error) {
      // If parsing fails, just leave the number as is
    }
  }

  changeCountry(event) {
    this.updateDisplay()
    this.updateFullNumber()
  }

  updateDisplay() {
    const selectedOption = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]
    if (selectedOption && selectedOption.value) {
      const flag = selectedOption.dataset.flag || ""
      const countryCode = selectedOption.value
      try {
        const callingCode = getCountryCallingCode(countryCode)
        this.countryCodeDisplayTarget.textContent = `${flag} +${callingCode}`
      } catch (error) {
        this.countryCodeDisplayTarget.textContent = flag
      }
    }
  }

  onPhoneInput(event) {
    // Try to detect country from pasted number with country code
    try {
      const phoneNumber = parsePhoneNumber(event.target.value)
      if (phoneNumber && phoneNumber.country) {
        event.target.value = phoneNumber.nationalNumber
        this.countrySelectTarget.value = phoneNumber.country
        this.updateDisplay()
      }
    } catch (error) {
      // Not a valid international number, that's fine
    }
    this.updateFullNumber()
  }

  updateFullNumber() {
    if (this.hasFullNumberTarget) {
      const countryCode = this.countrySelectTarget.value
      const nationalNumber = this.numberFieldTarget.value.replace(/\D/g, "")

      if (countryCode && nationalNumber) {
        try {
          const callingCode = getCountryCallingCode(countryCode)
          this.fullNumberTarget.value = `+${callingCode}${nationalNumber}`
        } catch (error) {
          this.fullNumberTarget.value = nationalNumber
        }
      } else {
        this.fullNumberTarget.value = nationalNumber
      }
    }
  }
}
